import {Component} from "react";
import styled from "styled-components";
import ArrowButton from "basicComponents/ArrowButton/ArrowButton";
import GlobalMessages from "messages/messages";
import {FormattedMessage} from "react-intl";
import * as PropTypes from "prop-types";

export default class TimePicker extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    hours: PropTypes.number.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    noLoop: PropTypes.bool,
  };

  static defaultProps = {
    min: 0,
    max: 24,
  };

  handleUpClicked = () => {
    const newHours = this.props.hours + 0.5;
    if (newHours > this.props.max) {
      if (!this.props.noLoop) {
        this.props.onChange(this.props.min);
      }
    } else {
      this.props.onChange(newHours);
    }
  };

  handleDownClicked = () => {
    const newHours = this.props.hours - 0.5;
    if (newHours < this.props.min) {
      if (!this.props.noLoop) {
        this.props.onChange(this.props.max);
      }
    } else {
      this.props.onChange(newHours);
    }
  };

  isUpDisabled() {
    return this.props.noLoop && this.props.hours >= this.props.max;
  }

  isDownDisabled() {
    return this.props.noLoop && this.props.hours <= this.props.min;
  }

  render() {
    return (
      <Wrapper>
        <Header />
        <Content>
          <div>
            <FormattedMessage {...GlobalMessages.duration} />
          </div>
          <ArrowButton
            disabled={this.isUpDisabled()}
            up
            onClick={this.handleUpClicked}
          />
          <HourWrapper>
            {`${this.props.hours} `}
            <FormattedMessage {...GlobalMessages.hoursFull} />
          </HourWrapper>
          <ArrowButton
            disabled={this.isDownDisabled()}
            down
            onClick={this.handleDownClicked}
          />
        </Content>
      </Wrapper>
    );
  }
}

const HourWrapper = styled.div`
  margin-top: -6px;
  margin-bottom: -6px;
`;

const Header = styled.div`
  height: 20px; // Arbitrary value in accordance with the height of the datePicker
  background-color: ${({ theme }) => theme.borderColor};
`;

const Wrapper = styled.div`
  width: 7rem;
  border-right: 1px solid ${({ theme }) => theme.borderColor};
  border-bottom: 1px solid ${({ theme }) => theme.borderColor};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
  background-color: white;
`;

const Content = styled.div`
  z-index: 9999999;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.padding}rem;
  padding-top: ${({ theme }) => theme.padding}rem;
`;
